
import { Inject, Injectable } from '@angular/core';

import { CompanyConfigureCommand, CompanyConfigureCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';

@CommandHandlerFor(CompanyConfigureCommand)
@Injectable({ providedIn: 'root'})
export class CompanyConfigureCommandHandler {
	private commandHandler: CompanyConfigureCommandHandlerBase;
	public constructor(
		@Inject(Http) http: HttpService
	) {
		this.commandHandler = new CompanyConfigureCommandHandlerBase(http);
	}

	public async handleAsync(cmd: CompanyConfigureCommand): Promise<any> {
		return await this.commandHandler.handleAsync(cmd);
	}
}
